/**
 * Allergies Service
 * Patient allergy tracking and management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CheckExposureRequestDto { 
    /**
     * Patient ID to check allergies for
     */
    patientId: string;
    /**
     * Element IDs of substances to check
     */
    substanceElementIds: Array<string>;
    /**
     * Type of intervention
     */
    interventionType: CheckExposureRequestDto.InterventionTypeEnum;
    /**
     * Whether to check for cross-reactivity
     */
    includeCrossReactivity: boolean;
    /**
     * Minimum severity threshold element ID to alert on
     */
    severityThresholdElementId?: string;
}
export namespace CheckExposureRequestDto {
    export type InterventionTypeEnum = 'medication' | 'procedure' | 'diet' | 'other';
    export const InterventionTypeEnum = {
        Medication: 'medication' as InterventionTypeEnum,
        Procedure: 'procedure' as InterventionTypeEnum,
        Diet: 'diet' as InterventionTypeEnum,
        Other: 'other' as InterventionTypeEnum
    };
}


